import { jsx as _jsx } from "react/jsx-runtime";
import { Redirect, Route, useLocation } from 'react-router-dom';
import Logger from '../lib/Logger';
import { getQueryParam } from '../routing/getQueryParam';
const LOG = Logger.getLogger('HubSpotForStartupsRoute');
export const HSFX_NONPROFITS_QUERY_PARAM_VALUE = 'hsfx-nonprofits';
export const HUBS_SIGNUP_CTA_QUERY_PARAM_KEY = 'hubs_signup-cta';

const HubSpotForStartupsRoute = props => {
  const {
    hash,
    search
  } = useLocation();
  const searchParams = new URLSearchParams(search);
  const hubsSignupCta = getQueryParam(HUBS_SIGNUP_CTA_QUERY_PARAM_KEY);

  if (hubsSignupCta === HSFX_NONPROFITS_QUERY_PARAM_VALUE) {
    LOG.info(`Redirecting to hubspot-for-nonprofits flow due to ${HUBS_SIGNUP_CTA_QUERY_PARAM_KEY} query parameter`, {
      extra: {
        currentUrl: window.location.toString(),
        documentReferrer: document.referrer
      }
    });
    return /*#__PURE__*/_jsx(Redirect, {
      to: {
        pathname: `/hubspot-for-nonprofits`,
        search: searchParams.toString(),
        hash
      }
    });
  }

  return /*#__PURE__*/_jsx(Route, Object.assign({}, props));
};

export default HubSpotForStartupsRoute;